import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import "./Enquiry.scss";
import searchIcon from "../../images/logo/shortlogo.png"
import { EnquiryURL } from "../../APIs/APIUrls";
import { useSnackbar } from "notistack";


const defaultFormState = {
    name: "",
    mobile: "",
    email: "",
    message: "",
    serviceType: "local",
    agreed: true,
};

function Enquiry({ isOpen, onClose, onSubmit, flagType, propertyId }) {

    const { enqueueSnackbar } = useSnackbar();

    const [formState, setFormState] = useState(defaultFormState);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const ctaConfigByType = {
        call: {
            title: "Call Now",
            icon: <span className="amr-enquiry-phone" aria-hidden="true">📞</span>,
            themeClass: "amr-enquiry-call-btn--call",
        },
        whatsapp: {
            title: "Chat on WhatsApp",
            icon: <span className="icon icon-whatsapp" aria-hidden="true" />,
            themeClass: "amr-enquiry-call-btn--whatsapp",
        },
        default: {
            title: "Submit Enquiry",
            icon: null,
            themeClass: "amr-enquiry-call-btn--submit",
        },
    };

    const ctaConfig = ctaConfigByType[flagType] || ctaConfigByType.default;

    useEffect(() => {
        if (isOpen) {
            setFormState(defaultFormState);
        }
    }, [isOpen]);

    const updateField = (field, value) => {
        setFormState((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleClose = () => {
        setFormState(defaultFormState);
        if (typeof onClose === "function") {
            onClose();
        }
    };

    const handleMobileChange = (event) => {
        const onlyDigits = event.target.value.replace(/\D/g, "").slice(0, 10);
        updateField("mobile", onlyDigits);
    };

    const InsertNewEnquiry = async (enquiryData) => {
        try {
            const response = await fetch(`${EnquiryURL}InsertEnquiry`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(enquiryData),
            });

            const data = await response.json();

            if (response.ok && data.Message == "Success") {
                return {
                    status: response.status,
                    data: data.data,
                    returnID: data.returnID,
                    success: true,
                    message: data.Message || "Success",
                };
            }

            return {
                status: response.status,
                data: null,
                returnID: null,
                success: false,
                message: data?.Message || "Failed",
            };
        } catch (error) {
            return {
                status: 500,
                data: null,
                returnID: null,
                success: false,
                message: error.message,
            };
        }
    };

    const handleInsertEnquiry = async (event) => {
        event.preventDefault();

        if (!formState.name.trim()) {
            enqueueSnackbar("Please fill in your name.", { variant: "warning" });
            return;
        }
        if (formState.mobile.length < 10) {
            enqueueSnackbar("Please enter a valid 10-digit mobile number.", { variant: "warning" });
            return;
        }
        if (!formState.agreed) {
            enqueueSnackbar("You must agree to the Terms and Conditions and Privacy Policy to proceed.", { variant: "warning" });
            return;
        }
        if (isSubmitting) {
            enqueueSnackbar("Your enquiry is being submitted. Please wait...", { variant: "info" });
            return;
        }

        let vendorid = JSON.parse(localStorage.getItem("id")) || 0;

        const payload = {
            PropertyId: propertyId || 0,
            VendorId: vendorid,
            Name: formState.name.trim(),
            Mobile: formState.mobile,
            Email: formState.email.trim() || null,
            Message: formState.message.trim() || null,
            IsForCall: flagType === "call" ? true : false,
            IsForWhatsapp: flagType === "whatsapp" ? true : false,
            IsForEnquiry: flagType === "enquiry" ? true : false,
            IsActive: true,
            CreatedBy: 0,
        };

        setIsSubmitting(true);

        const response = await InsertNewEnquiry(payload);

        setIsSubmitting(false);

        if (response?.success) {
            enqueueSnackbar("Enquiry submitted successfully!", { variant: "success" });
            handleClose();
            return;
        }

        // if (typeof onSubmit === "function") {
        //     onSubmit({
        //         name: formState.name.trim(),
        //         mobile: formState.mobile,
        //         email: formState.email.trim(),
        //         message: formState.message.trim(),
        //         serviceType: formState.serviceType,
        //         agreed: formState.agreed,
        //         apiResponse: response,
        //     });
        // }


    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={handleClose}
            closeTimeoutMS={300}
            style={{
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.55)",
                },
            }}
            className={{
                base: "amr-enquiry-modal-content",
                afterOpen: "amr-enquiry-modal-content-open",
                beforeClose: "amr-enquiry-modal-content-close",
            }}
            overlayClassName={{
                base: "amr-enquiry-modal-overlay",
                afterOpen: "amr-enquiry-modal-overlay-open",
                beforeClose: "amr-enquiry-modal-overlay-close",
            }}
            ariaHideApp={false}
        >
            <div className="amr-enquiry-shell">
                <button
                    type="button"
                    className="amr-enquiry-close"
                    aria-label="Close enquiry modal"
                    onClick={handleClose}
                >
                    <span>×</span>
                </button>

                {/* <div className="amr-enquiry-top-decor" />
        <div className="amr-enquiry-grid-decor" /> */}

                <div className="amr-enquiry-brand">
                    <span className="amr-enquiry-brand-icon" aria-hidden="true">
                        <img
                            src={searchIcon}
                            alt="AskMeReality Logo"
                            className="amr-enquiry-logo"
                        />
                    </span>
                    <h4>AskMeReality </h4>
                </div>

                <p className="amr-enquiry-subtitle">
                    {
                        flagType === 'call' ? "Please provide your details to initiate a call with the AskMeReality team." :
                            flagType === 'whatsapp' ? "Please provide your details to initiate a WhatsApp" :
                                "Please provide your details to submit an enquiry to the Property Owner/ Vendor."
                    }

                </p>

                <form className="amr-enquiry-form" onSubmit={handleInsertEnquiry}>
                    <input
                        type="text"
                        placeholder="Name*"
                        value={formState.name}
                        onChange={(event) => updateField("name", event.target.value)}
                        className="amr-enquiry-input"
                        required
                    />

                    <input
                        type="tel"
                        inputMode="numeric"
                        placeholder="Enter Mobile Number*"
                        value={formState.mobile}
                        onChange={handleMobileChange}
                        className="amr-enquiry-input"
                        required
                    />

                    <input
                        type="email"
                        placeholder="Email (Optional)"
                        value={formState.email}
                        onChange={(event) => updateField("email", event.target.value)}
                        className="amr-enquiry-input"
                    />

                    <textarea
                        placeholder="Message (Optional)"
                        value={formState.message}
                        onChange={(event) => updateField("message", event.target.value)}
                        className="amr-enquiry-input amr-enquiry-textarea"
                        rows={3}
                    />

                    <label className="amr-enquiry-checkbox">
                        <input
                            type="checkbox"
                            checked={formState.agreed}
                            onChange={(event) => updateField("agreed", event.target.checked)}
                        />
                        <span>
                            I Agree to <a href="#">Terms and Conditions, and Privacy Policy</a>
                        </span>
                    </label>

                    <button
                        type="submit"
                        className={`amr-enquiry-call-btn ${ctaConfig.themeClass}`}
                        disabled={!formState.name.trim() || formState.mobile.length < 10 || !formState.agreed || isSubmitting}
                    >
                        {/* {ctaConfig.icon && <span className="amr-enquiry-call-btn-icon">{ctaConfig.icon}</span>} */}
                        <span className="amr-enquiry-call-btn-title">{ctaConfig.title}</span>

                    </button>

                    <button type="button" className="amr-enquiry-later" onClick={handleClose}>
                        Maybe Later
                    </button>
                </form>
            </div>
        </Modal>
    );
}

export default Enquiry;
